import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class GoogleCloudService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = "/api/internal/google-cloud";

  /**
   * Upload a file from S3 to Google Cloud. Calls the backend to handle the transfer and returns the Google Cloud URI.
   *
   * "s3FilePath": The path of the file in S3.
   *
   * @returns An Observable with the Google Cloud URI.
   */
  async uploadFileFromS3(s3FilePath: string): Promise<void> {
    const url = `${this.baseUrl}/upload-from-s3`;
    const params = new HttpParams().set("s3FilePath", s3FilePath);
    await firstValueFrom(this.httpClient.post<{ uri: string }>(url, null, { params }));
  }

  /**
   * Delete a file from Google Cloud. Expects the backend to return a JSON object like: "status": "success",
   * "deletedFilePath": "filename.pdf"
   */
  async deleteFile(filePath: string): Promise<{ status: string; deletedFilePath: string }> {
    const params = new HttpParams().set("filePath", filePath);
    const response = await firstValueFrom(
      this.httpClient.delete<{ status: string; deletedFilePath: string }>(`${this.baseUrl}/delete`, { params }),
    );
    return response;
  }
}
